module.exports = __webpack_public_path__ + "img/camera.d46f60ce.svg";